import { z } from "zod";
import { BeneficiaryValidationSchema } from "../treezor/index.js";

export default {
  params: z.object({
    name: z.string(),
    iban: z.string(),
  }),
  response: BeneficiaryValidationSchema,
};
